import config from 'SRC/config/config.json'

export const adsListViews = config.adsList.adsListViews
